<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<m-search-item label="部门编号">
                    <c-input name="parent_id" type="hidden" value="0"></c-input>
					<c-input name="department_code"></c-input>
				</m-search-item>
				<m-search-item label="部门名称">
					<c-input name="department_name"></c-input>
				</m-search-item>
			</m-search>

			<m-operate>
				<c-button color="main" v-if="auth('b_department_edit')" prepend-icon="tf-add" @click="create()">创建部门</c-button>
			</m-operate>

			<c-table ref="list" height="grow">
                <!-- 部门名称 -->
                <c-table-column
                        type="tree"
                        label="部门名称"
                        add-node="添加子部门"
                        level-limit="5"
                        width="300"
                        @handle="loadChildren"
                        @add="addHandle"
                >
                    <template #default="{data}">
                        {{data.department_name}}
                    </template>
                </c-table-column>


                <c-table-column
                        label="部门编号"
                        name="department_code"
                        width="100"
                >
                </c-table-column>

                <c-table-column
                        label="负责人"
                        width="100"
                        name="department_manager_name"
                >
                </c-table-column>
                <!-- 分管领导 -->
                <c-table-column
                        label="分管领导"
                        width="100"
                        name="department_leader_name"
                ></c-table-column>
                <!-- 部门人数-->
                <c-table-column
                        label="部门人数"
                        name="user_count"
                        width="100"
                ></c-table-column>

				<c-table-column
					label="创建人"
					name="create_user_realname"
                    width="100"
				>
					<template #default="{data}">
						<span v-if="data.is_manage == 1">-</span>
						<span v-else>{{data.create_user_realname}}</span>
					</template>
				</c-table-column>

				<c-table-column
					label="创建时间"
					name="create_date"
					width="140"
				></c-table-column>

				<c-table-column
					type="button"
					label="操作"
					width="110"
				>
					<template #default="row">
						<c-table-button v-if="auth('b_department_edit')" icon="tf-edit" @click="edit(row)">编辑</c-table-button>
						<c-table-button v-if="auth('b_department_edit')" icon="tf-trash" @click="remove(row)">删除</c-table-button>
					</template>
				</c-table-column>
			</c-table>
            <!--编辑部门-->
            <c-dialog ref="dialog" :title="addFlag?'创建部门':(editFlag ? '编辑部门' : '添加部门')" width="500" mode="slide" @resolve="addChild">
                <c-form ref="form" column="1" vertical unit-width="100%">
                    <c-input type="hidden" name="id"></c-input>
                    <c-input type="hidden" name="department_manager"></c-input>
                    <c-input type="hidden" name="department_leader"></c-input>
                    <c-form-item label="部门名称" required>
                        <c-input name="department_name"></c-input>
                    </c-form-item>
                    <c-form-item label="部门编号" required>
                        <c-input name="department_code"></c-input>
                    </c-form-item>
                    <c-form-item label="部门负责人">
                        <div class="flex-center">
                            <c-select name="department_manager" async @search="searchUser" :value-data="selectedManager" clearable>
                                <template #option="{data, selected}">
                                    <select-option
                                            :name="data.name"
                                            :info="[
                                `${data.data.department_name || ''} | ${data.data.position_name || ''}`
                            ]"
                                            :selected="selected"
                                    ></select-option>
                                </template>
                            </c-select>
                            <c-button color="dark" style="margin-left: 10px;" @click="clearSelect(1)"><i class="tf">&#xe62d;</i>清除</c-button>
                        </div>
                    </c-form-item>
                    <c-form-item label="分管领导">
                        <div class="flex-center">
                            <c-select name="department_leader" async @search="searchUser" :value-data="selectedLeader" clearable>
                                <template #option="{data, selected}">
                                    <select-option
                                            :name="data.name"
                                            :info="[
                                `${data.data.department_name || ''} | ${data.data.position_name || ''}`
                            ]"
                                            :selected="selected"
                                    ></select-option>
                                </template>
                            </c-select>
                            <c-button color="dark" style="margin-left: 10px;" @click="clearSelect(2)"><i class="tf">&#xe62d;</i>清除</c-button>
                        </div>
                    </c-form-item>
                    <c-form-item label="备注">
                        <c-input name="remark" type="textarea"></c-input>
                    </c-form-item>
                </c-form>
            </c-dialog>
		</module>
        <!-- 添加人员选择器 -->
        <person-selector ref="staffSelector" @confirm="handleStaffSelect"></person-selector>
	</page>

</template>

<script>
	import departmentEdit from "./department_edit.vue";
    import personSelector from "@/components/public/person_selector.vue"; // 引入人员选择器

	export default {
        components: {
            departmentEdit,
            personSelector
        },

        data() {
            return {
                editFlag: false,
                editLevel: 0,
                default_parent_id: 0,
                _edit: 0,
                _parent: 0,
                _resolve: null,
                addFlag: false,
                currentStaffType: 1, // 当前选择的人员类型 1:负责人 2:分管领导
                selectedManager: [], // 选中的用户数据
                selectedLeader: [] // 选中的用户数据
            }
        },

        mounted() {
            this.searchHandle();
        },

        methods: {
            /************搜索列表**************/
            searchHandle(data) {
                if (!data) {
                    data = {parent_id: this.default_parent_id};
                }
                this.$refs.list.load({
                    url: '/department/list',
                    data
                });
            },
            create() {
                this.addFlag = true;
                this.addHandle(0, data => {
                    this.$refs.list.push([data]);
                });
            },
            addHandle(row, resolve) {
                this.editFlag = false;
                this.editLevel = row && row.nodeData ? row.nodeData.level + 1 : 0;
                this._edit = 0;
                this._parent = row ? row.data.id : this.default_parent_id;
                this._resolve = data => {
                    resolve(data);
                };
                this.$refs.form.clear();
                if (this.$refs.form) {
                    this.$refs.form.clear();
                    // 清空负责人和分管领导的相关字段
                    this.$refs.form.set({
                        department_manager: '',
                        department_manager_name: '',
                        department_leader: '',
                        department_leader_name: ''
                    });
                }
                this.$refs.dialog.open();
            },

            addChild(stop, next) {
                stop();
                this.$refs.form.submit({
                    url: this.editFlag ? 'department/edit' : '/department/add',
                    rule: {
                        department_name: '请填写部门名称',
                        department_code: '请填写部门编号',
                    },
                    dataFormatter: data => {
                        data.parent_id = this._parent;
                        data.department_id = data.id;
                        return data;
                    },
                    success: (data, res) => {
                        this.$message({
                            message: '操作成功',  // 提示内容,
                        });
                        next();
                        this._resolve(res);
                    }
                })
            },

            //编辑-弹框
            edit(row) {
                this.addFlag = false;
                this.editFlag = true;
                this.editLevel = row.data.nodeData ? (row.data.nodeData.level || 0) : 0;
                this._edit = row.data.id;
                this._parent = row.data.parent_id;
                this._resolve = data => {
                    row.update(data);
                };
                if (this.$refs.form) {
                    this.$refs.form.clear();
                    // 设置表单数据，包括负责人和分管领导信息
                    const formData = {
                        ...row.data,
                        department_manager_name: row.data.department_manager_name || '',
                        department_leader_name: row.data.department_leader_name || ''
                    };
                    if (row.data.department_manager) {
                        this.selectedManager = [
                            {
                                name: row.data.department_manager_name,
                                value: row.data.department_manager
                            }
                        ];
                    }
                    if (row.data.department_leader) {
                        this.selectedLeader = [
                            {
                                name: row.data.department_leader_name,
                                value: row.data.department_leader
                            }
                        ];
                    }
                    this.$refs.form.set(formData);
                }
                this.$refs.dialog.open();
            },

            clearSelect(staffType) {
                const fieldName = staffType === 1 ? 'department_manager' : 'department_leader';
                const nameField = staffType === 1 ? 'department_manager_name' : 'department_leader_name';

                // 清空表单值
                this.$refs.form.set({
                    [fieldName]: '',
                    [nameField]: ''
                });

                // 显示提示信息
                this.$message({
                    message: `已清除${staffType === 1 ? '部门负责人' : '分管领导'}选择`,
                })
            },

            // 处理人员选择确认
            handleStaffSelect(selectedData) {
                const fieldName = this.currentStaffType === 1 ? 'department_manager' : 'department_leader';
                const nameField = this.currentStaffType === 1 ? 'department_manager_name' : 'department_leader_name';

                // 设置表单值
                this.$refs.form.set({
                    [fieldName]: selectedData.id,
                    [nameField]: selectedData.name
                });

                // 显示选择结果
                this.$message({
                    message: `已选择${this.currentStaffType === 1 ? '部门负责人' : '分管领导'}：${selectedData.name}`,
                    type: 'success'
                });
            },

            loadChildren(row, resolve) {
                this.request({
                    url: '/department/list',
                    data: {
                        parent_id: row.data.id
                    },
                    success: data => {
                        resolve(data);
                    }
                });
            },

            /************删除部门**************/
            remove(row) {
                this.$confirm({
                    message: '确认删除部门【' + row.data.department_name + '】？删除后不可恢复',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/department/delete',
                            data: {id: row.data.id},
                            loading: true,
                            success: data => {
                                this.$message({
                                    message: '删除成功',  // 提示内容,
                                    type: 'success'
                                });
                                row.remove();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {
                    },  // 取消按钮回调
                });
            },

            /*******搜索用户*****************/
            searchUser(keyword, resolve){
                this.request({
                    url:'/system/options',
                    data: {
                        options_code:'SYSUSER',
                        keyword:keyword
                    },
                    success:data => {
                        resolve(data);
                    }
                })
            },
        },
    }
</script>

<style lang="stylus" scoped>
</style>